/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
// Add this to your theme.js file or create a custom JavaScript file

document.addEventListener('DOMContentLoaded', function() {
  // Find all tab collection sections
  const tabCollections = document.querySelectorAll('section[id^="TabCollections--"]');
  
  tabCollections.forEach(section => {
    const tabLinks = section.querySelectorAll('.tab-link');
    const viewAllButtons = section.querySelectorAll('.tab-view-all-btn');
    
    if (tabLinks.length > 0 && viewAllButtons.length > 0) {
      // Add click event listeners to all tab links
      tabLinks.forEach(tab => {
        tab.addEventListener('click', function() {
          const tabIndex = this.getAttribute('data-tab');
          toggleViewAllButtons(tabIndex);
        });
        
        tab.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            const tabIndex = this.getAttribute('data-tab');
            toggleViewAllButtons(tabIndex);
          }
        });
      });
      
      // Function to toggle visibility of view all buttons
      function toggleViewAllButtons(activeTabIndex) {
        viewAllButtons.forEach(button => {
          if (button.getAttribute('data-tab-index') === activeTabIndex) {
            button.classList.remove('hidden');
          } else {
            button.classList.add('hidden');
          }
        });
      }
    }
  });

  // remove hover img container is empty
  const allProductCards = document.querySelectorAll('.product-item__bg__under');
  allProductCards.forEach(card => {
    if (card.children[0].children.length < 1) {
      card.remove();
    };
  });
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
